import React from "react";

import css from "./MessagesPage.module.css";
import TitleMenuMessage from "../../components/messagesSection/TitleMenuMessage/TitleMenuMessage";
import { Outlet } from "react-router-dom";

const MessagesPage = () => {
  return (
    <section className={css.wrap}>
      <section className={css.menuBlock}>
        <TitleMenuMessage />
      </section>

      <section className={css.outletBlock}>
        <Outlet />
      </section>
    </section>
  );
};

export { MessagesPage };
